var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLineChartTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8805 17.0006H6.5948V5.8577C6.5948 5.77913 6.53051 5.71484 6.45194 5.71484H5.45194C5.37337 5.71484 5.30908 5.77913 5.30908 5.8577V18.1434C5.30908 18.222 5.37337 18.2863 5.45194 18.2863H18.8805C18.9591 18.2863 19.0234 18.222 19.0234 18.1434V17.1434C19.0234 17.0648 18.9591 17.0006 18.8805 17.0006ZM8.48408 14.2452C8.53944 14.3006 8.62873 14.3006 8.68587 14.2452L11.1555 11.7881L13.4341 14.0809C13.4894 14.1363 13.5805 14.1363 13.6359 14.0809L18.5537 9.16484C18.6091 9.10949 18.6091 9.01841 18.5537 8.96306L17.8466 8.25591C17.8197 8.22933 17.7835 8.21441 17.7457 8.21441C17.7079 8.21441 17.6716 8.22933 17.6448 8.25591L13.5377 12.3613L11.2627 10.072C11.2358 10.0454 11.1995 10.0305 11.1618 10.0305C11.124 10.0305 11.0877 10.0454 11.0609 10.072L7.77873 13.3345C7.75214 13.3613 7.73723 13.3976 7.73723 13.4354C7.73723 13.4732 7.75214 13.5094 7.77873 13.5363L8.48408 14.2452Z",
    fill: "#666666"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartTile);
export default ForwardRef;